import $ from 'jquery';
import '@/scripts/helpers/polyfills';
import 'slick-carousel/slick/slick';
import lazyframe from 'lazyframe';
import { bindJQuery } from '@/scripts/helpers/library';
import { accordion } from '../modules/containers/accordion/index';
import { detectBrowser } from '@/scripts/helpers/detectBrowser';

bindJQuery();

$(document).ready(() => {
  accordion();
  detectBrowser();

  const elements = $('.video-player__lazyframe');

  lazyframe(elements, {
    onAppend: iframe => {
      $(iframe).attr('allow', 'autoplay');
    },
  });

  const $slider = $('.js-slider');

  $slider.on('init', () => {
    $('.carousel').addClass('is-visible');
  });

  $slider.slick({
    dots: true,
    arrows: false,
    infinite: false,
    speed: 300,
    adaptiveHeight: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    lazyLoad: 'ondemand',
    accessibility: false,
    responsive: [
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  });
});
